import { Check, HandCoins, Wallet } from "lucide-react";
import { cn } from "@/lib/utils";
import { TRY } from "@/lib/format";
import { PAY_OPTIONS, PAY_LABEL } from "@/lib/pos";

const METHODS = PAY_OPTIONS.filter(([v]) => v !== "veresiye");
const seg = (on) => cn("inline-flex items-center justify-center gap-1.5 rounded-lg px-2 py-2 text-xs font-bold transition-colors", on ? "bg-card shadow-sm text-foreground" : "text-muted-foreground hover:text-foreground");

// Fatura ödemesi: alındıysa yöntem seçilir → faturaya tahsilat işlenir (cari hesapta görünür); alınmadıysa cari hesaba borç kalır
export function InvoicePaySection({ received, setReceived, method, setMethod, total, contactTitle }) {
  const who = contactTitle || "seçilen cari";
  return (
    <div className="space-y-2" data-testid="ci-pay">
      <div className="grid grid-cols-2 gap-1 rounded-xl bg-muted p-1">
        <button type="button" className={seg(received)} onClick={() => setReceived(true)} data-testid="ci-pay-received"><Wallet className="h-3.5 w-3.5" />Ödeme Alındı</button>
        <button type="button" className={seg(!received)} onClick={() => setReceived(false)} data-testid="ci-pay-open"><HandCoins className="h-3.5 w-3.5" />Alınmadı</button>
      </div>
      {received && (
        <div className="grid grid-cols-3 gap-1.5" data-testid="ci-pay-methods">
          {METHODS.map(([v, l, Icon]) => {
            const on = method === v;
            return (
              <button key={v} type="button" onClick={() => setMethod(v)} data-testid={`ci-pay-method-${v}`}
                className={cn("flex flex-col items-center gap-1 rounded-xl border-2 p-2 text-[11px] font-semibold transition-all active:scale-[0.98]", on ? "border-emerald-700 bg-emerald-700 text-white" : "border-border bg-card text-foreground hover:border-emerald-400")}>
                <Icon className={cn("h-4 w-4", on ? "text-white" : "text-muted-foreground")} />
                <span className="leading-tight text-center">{l}</span>
                {on && <Check className="h-3 w-3" />}
              </button>
            );
          })}
        </div>
      )}
      <p className={cn("rounded-lg border px-2.5 py-2 text-[11px] leading-snug", received ? "border-emerald-300 bg-emerald-50 text-emerald-950 dark:border-emerald-700 dark:bg-emerald-950 dark:text-emerald-50" : "border-amber-300 bg-amber-50 text-amber-950 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-50")} data-testid="ci-pay-hint">
        {received
          ? <><b>{TRY(total)} {PAY_LABEL[method]}</b> tahsilatı faturaya işlenir; <b>{who}</b> hesabında fatura ödemesi olarak görünür.</>
          : <><b>{TRY(total)}</b> <b>{who}</b> hesabına borç olarak kalır; tahsilat sonra faturadan girilir.</>}
      </p>
    </div>
  );
}
